import React from 'react';

import Button from '../../../Components/button';

const ContentSection: React.FC<{content: string, date: Date, horarioFim: string, buttons: Array<{ text: string, link: string }>, imagem: string, apoio: Array<{imagem: string}>, programacao: string, type: string, inscricao: string, eventoAberto: boolean}> = ({content, date, horarioFim, imagem, apoio, programacao, type, inscricao, buttons, eventoAberto}) => {

    return (
        <section className='pt-4 pb-12 md:-mt-8'>
            <div className="max-w-screen-lg 2xl:max-w-screen-xl mx-auto px-4">
                <div className="grid lg:grid-cols-5 gap-x-12 gap-y-2">
                    <div className='lg:col-span-3'>
                        <div className="flex gap-6 items-center">
                            {date &&
                                <div className={`flex flex-col shrink-0 h-24 text-center w-16 ${eventoAberto ? 'opacity-40' : ''}`}>
                                    <div className="flex items-center justify-center bg-main-pink border-2 border-main-pink rounded-t-xl text-white text-4xl font-semibold h-1/2 transition-all duration-200">
                                        {date.toLocaleDateString('pt-br', { day: '2-digit' })}
                                    </div>

                                    <div className="flex flex-col items-center justify-center border-2 border-main-pink rounded-b-xl shrink-0 h-1/2 py-2 px-0">
                                        <span className="text-xl font-semibold tracking-wider uppercase -mt-1">
                                            {date.toLocaleDateString('pt-br', { month: 'short' }).replace('.', '')}
                                        </span>
                                        <span className="text-xs font-semibold tracking-[3px] indent-[2px] -mt-1">
                                            {date.toLocaleDateString('pt-br', { year: 'numeric' })}
                                        </span>
                                    </div>
                                </div>
                            }
                            {eventoAberto ? 
                                <h3 className={`flex text-2xl flex-col font-semibold`}>
                                    <span className={`font-semibold ${type == 'Presencial' ? 'text-main-pink' : 'text-main-blue'}`}>
                                        Evento já realizado.
                                    </span>
                                </h3>
                            : 
                                <h3 className={`flex text-2xl flex-col font-semibold`}>
                                    <span className={`font-semibold ${type == 'Presencial' ? 'text-main-pink' : 'text-main-blue'}`}>
                                        Evento {type}.
                                    </span>
                                    {inscricao && 
                                        'Inscreva-se!'
                                    }
                                </h3>
                            }
                        </div>

                        <div className="mt-8 text-sm 2xl:text-base" dangerouslySetInnerHTML={{ __html: content }} />

                        {!eventoAberto &&
                            <div className="mt-6 grid md:grid-cols-2 gap-4">
                                {inscricao &&
                                    <Button text="Inscreva-se" link={inscricao} arrow={true} color="pink" target='_blank' />
                                }
                                {programacao && 
                                    <Button text="Baixar programação" link={programacao} arrow={false} color="blue" target='_blank' /> 
                                }

                                {buttons &&
                                    buttons.map((button, index) => (
                                        <Button key={index} text={button.text} link={button.link} arrow={false} color="pink" target='_blank' />
                                    ))
                                }
                            </div>
                        }

                        <div className="mt-10 grid md:grid-cols-2 gap-4 max-w-[470px]">
                            
                        </div>

                        <section className='py-8 mt-4 relative z-10'>
                            <div className="mx-auto py-8 px-8 md:px-14 bg-light-yellow rounded-3xl grid md:grid-cols-3 gap-4 items-center relative before:content-[''] before:h-full before:w-[95%] before:left-1/2 before:-translate-x-1/2 before:bg-main-blue/50 before:rounded-3xl before:absolute md:before:-rotate-2 before:-rotate-3 before:-z-10">
                                <h3 className="font-semibold text-xl md:text-2xl text-balance md:col-span-2">
                                    Siga nosso instagram e acompanhe as novidades. 
                                </h3>

                                <div className="flex justify-center items-center">
                                    <a href="https://www.instagram.com/uniexpo_oficial/" target='_blank' className='uppercase bg-main-pink text-white text-center font-semibold rounded-full p-2 w-full transition-all duration-200 ease-in-out hover:bg-main-blue'>
                                        Seguir
                                    </a>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="lg:col-span-2 pt-12">
                        {imagem && 
                            <img src={imagem} alt="Lorem Ipsum" className='w-full h-auto max-w-[500px] mx-auto' />
                        }

                        {apoio.length > 0 && 
                            <div className="flex mt-6 gap-2 items-center text-sm justify-center">
                                Apoio:

                                <div className="grid grid-cols-2 gap-y-4">
                                    {apoio.map((item, index) => (
                                        <img key={ index} src={item.imagem} alt="Imagem do apoiador" className="w-full h-auto py-2 px-4 odd:border-r border-black/20" />
                                    ))}
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContentSection;